import { createAction } from '@reduxjs/toolkit';
import { IMessageModel } from '../../../model/communication/Message';

export const toggleConferencing = createAction<{ message: IMessageModel; token: string } | undefined, 'TOGGLE_VIDEO_CONFERENCING'>('TOGGLE_VIDEO_CONFERENCING');
export const updateConferencingMessage = createAction<{ message: IMessageModel } | undefined, 'UPDATE_VIDEO_CONFERENCING_MESSAGE'>('UPDATE_VIDEO_CONFERENCING_MESSAGE');
export const toggleSpeakersDynamic = createAction<{} | undefined, 'TOGGLE_SPEAKERS_DYNAMIC'>('TOGGLE_SPEAKERS_DYNAMIC');
export const setSpeakersDynamic = createAction<{ setDynamic: boolean } | undefined, 'SET_SPEAKERS_DYNAMIC'>('SET_SPEAKERS_DYNAMIC');
